<template>
  <v-layout column>
    <span class="title text-xs-left mb-2">Users</span>
    <v-divider class="grey"></v-divider>
    <br>
    <v-dialog v-model="deleteDialog" max-width="350" persistent>
      <v-card>
        <v-card-title class="headline grey lighten-2">
          <!-- <v-icon medium color="warning">warning</v-icon> -->
          Delete User
        </v-card-title>
        <v-card-text class="text-xs-left">
          Are you sure you want to delete this record?
        </v-card-text>
        <v-card-actions>
          <v-flex layout row wrap>
            <v-flex xs12 sm6 pl-3 pr-3 pb-3>
              <v-btn class="error" block dark flat="flat" @click="deleteDialog = false">Cancel</v-btn>
            </v-flex>
            <v-flex xs12 sm6 pl-3 pr-3 pb-3>
              <v-btn class="primary" block dark flat="flat" @click="deleteRecord()">Confirm</v-btn>
            </v-flex>
          </v-flex>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="addUserDialog" max-width="850" persistent>
      <v-card>
        <v-card-title class="grey lighten-2">
          <!-- <v-icon medium color="warning">warning</v-icon> -->
          <span class="subheading"> Add User </span>
          <v-btn class="close" icon right flat="flat" @click="addUserDialog = false"><v-icon small >close</v-icon></v-btn>
        </v-card-title>
        <v-flex layout row wrap pt-2 pb-2 mb-4 text-xs-left text-sm-left text-md-center text-lg-center>

            <v-flex layout row wrap pt-2 pb-2>
                <v-flex xs6 pr-2 pl-2 pt-2 pb-4>
                    <v-text-field
                    v-model="form.email"
                    type="text"
                    name="email"
                    label="Email"
                    box
                    ></v-text-field>
                </v-flex>
                <v-flex xs6 pr-2 pl-2 pt-2 pb-4>
                    <v-text-field
                    v-model="form.name"
                    type="text"
                    name="name"
                    label="Name"
                    box
                    ></v-text-field>
                </v-flex>

                <v-flex xs6 pr-2 pl-2 pt-2 pb-4>
                    <v-text-field
                            v-model="form.password"
                            type="text"
                            name="password"
                            label="Password"
                            box
                    ></v-text-field>
                </v-flex>

                <v-flex xs6 pr-2 pl-2 pt-2 pb-4>
                    <v-autocomplete :items="$store.getters.getUserTypes.sort()" label="User Role"
                                    item-text="name" item-value="id" placeholder=""
                                    v-model="form.role" box >

                    </v-autocomplete>
                </v-flex>
            </v-flex>

        </v-flex>
        <v-card-actions>
          <v-flex xs12 layout row wrap>
            <v-flex xs12 sm6 pl-2 pr-2 pb-2>
              <v-btn class="error" block dark flat="flat" @click="addUserDialog = false">Cancel</v-btn>
            </v-flex>
            <v-flex xs12 sm6 pl-2 pr-2 pb-2>
              <v-btn class="primary" block dark flat="flat" v-on:click="createUser()">Ok</v-btn>
            </v-flex>
          </v-flex>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-card>
      <v-toolbar flat dense class="primary" dark>
        <!-- <v-toolbar-title>Users</v-toolbar-title>
        <v-spacer></v-spacer> -->
        <v-text-field xs6 v-model="searchText" prepend-icon="search" label="Search" color="white" single-line clearable hide-details></v-text-field>
        <v-spacer></v-spacer>
        <v-btn v-show="$store.state.auth.user.role!=4" dark class="primary darken-2" flat @click="addUserDialog = true"><v-icon class="pr-3">add</v-icon>Add User</v-btn>
        <v-btn v-show="$store.state.auth.user.role!=4" dark class="primary darken-2" flat @click="massCreateUser()"><v-icon class="pr-3">add</v-icon>Import Admin Users</v-btn>
        <v-btn v-show="$store.state.auth.user.role!=4" dark class="primary darken-2" flat @click="massStudentFilter()"><v-icon class="pr-3">add</v-icon>Import Assigned Students</v-btn>
        <v-btn color="primary" dark class="mb-2" icon @click="getAll()"><v-icon>refresh</v-icon></v-btn>
      </v-toolbar>

      <v-data-table v-if="$store.state.users.users" :rows-per-page-items="rows" :headers="$store.state.users.users.headers"
                    :items="$store.getters.filterByUser" :loading="loading" :search="searchText" class="elevation-2">
        <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
        <template slot="items" slot-scope="props">
          <tr @click="highlightDevice = props.item" :class="{'grey lighten-3':highlightDevice == props.item}">
            <td v-for="(header, index) in $store.state.users.users.headers" :key="index" :class="'text-xs-'+header.align">
              <span v-if="header.value != 'actions'">{{ props.item[header.value] }}</span>
              <span v-else v-show="$store.state.auth.user.role==1">
                <v-btn icon class="grey lighten-4" @click="edit(props.item)">
                  <v-icon color="primary">edit</v-icon>
                </v-btn>
                <v-btn icon class="grey lighten-4" @click="deletePrompt(props.item)">
                  <v-icon color="accent">delete</v-icon>
                </v-btn>
              </span>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
  </v-layout>
</template>

<script>
import UserService from "@/services/UserService";

export default {
  name: "AllUsers",
  components: {},
  data() {
    return {
      searchText: null,
      highlightDevice: null,
      loading: false,
      loadingTime: 1000,
      deleteDialog: false,
      selectedId: null,
        addUserDialog: false,
        form: {
            name: null,
            email: null,
            password: null,
            role: null,
        },
      rows:[10,20,30,{"text":"$vuetify.dataIterator.rowsPerPageAll","value":-1}]
    };
  },
  mounted() {
    this.getAll();
  },
  methods: {
    edit: function(user){
      this.$store.dispatch('editUser', JSON.parse(JSON.stringify(user)));
      this.$router.push({name: 'editUser', params: {id: user.email}})
    },
    deletePrompt: function(user){
      this.selectedId = user.email;
      this.deleteDialog = true;
    },
    temp: function (){
      this.$store.dispatch("logout");
      this.$session.destroy();
      this.$router.push({ name: "signIn" });
    },
    async deleteRecord() {
      try {
        var color = "info";
        var user ={email: this.selectedId};
        console.log(user);
        const response = await UserService.deleteRecord(user);
        if (response.data.code > 200) {
          this.deleteDialog = false;
          color = "warning";
        } else if (response.data.result == 2000) {
          this.deleteDialog = false;
          // this.$router.push({name: 'allUsers'})
          this.getAll()
        }
        this.$store.dispatch("setSnackbar", {show: true, text: response.data.message, color: color, x: "right", timeout: 3000});
      } catch (err) {
        console.log(err);
        this.$store.dispatch("setSnackbar", {show: true, text: "Error occured", color: "error", x: "right", timeout: 3000});
      }
    },
    async getAll() {
      try {
        var color = "info";
        const response = await UserService.getAll();
        const userTypeResponse = await UserService.getUserTypes();

        this.$store.dispatch("setUserTypes", userTypeResponse.data.data);

        console.log(response.data.data);
        console.log("User Types", userTypeResponse.data.data);

          console.log("stored user types ", this.$store.state.users.types);
        if (response.data.code > 200) {
          color = "warning";
        } else if (response.data.result == 2000) {
          this.$store.dispatch("setUsers", response.data.data);
        }
        this.$store.dispatch("setSnackbar", {show: true, text: response.data.message, color: color, x: "right", timeout: 3000});
      } catch (err) {
        console.log(err);
        this.$store.dispatch("setSnackbar", {show: true, text: "Error occured", color: "error", x: "right", timeout: 3000});
      }
    },
      async createUser(){
          var color = "info";
          console.log("CreateUser");
          // var account =  JSON.parse(JSON.stringify(this.$store.state.accounts.editAccount));

          // let admin = JSON.parse(JSON.stringify(this.$store.state.users.editUser));
          // console.log(admin.id);

          // this.form.admin_id = admin.id;
          console.log("create user: ", this.form);
          const response = await UserService.create(this.form);
          // console.log("add student response: ", response);

          if (response.data.code > 200) {
              color = "warning";
          } else if (response.data.result == 2000) {
              // this.$store.dispatch("setCustomerVehicles", response.data.data);
              // this.allItems = response.data.data;
              // this.total = response.data.total
              // console.log("allitems: ", this.allItems);
              this.getAll();
              this.addUserDialog = false;
          }

          this.$store.dispatch("setSnackbar", {show: true, text: response.data.message, color: color, x: "left", timeout: 3000});
      },
      async massCreateUser(){
        this.loading = true;
          var color = "info";
          console.log("MassCreateUser");
          // console.log("create user: ", this.form);
          const response = await UserService.massCreate();
          // console.log("add student response: ", response);

          if (response.data.code > 200) {
              color = "warning";
          } else if (response.data.result == 2000) {
              this.getAll();
              this.addUserDialog = false;
          }
          this.loading = false;
          this.$store.dispatch("setSnackbar", {show: true, text: response.data.message, color: color, x: "left", timeout: 3000});
      },
      async massStudentFilter(){
        this.loading = true;
          var color = "info";
          console.log("massStudentFilter");
          // console.log("create user: ", this.form);
          const response = await UserService.massStudentFilter();
          // console.log("add student response: ", response);

          if (response.data.code > 200) {
              color = "warning";
          } else if (response.data.result == 2000) {
              this.getAll();
              this.addUserDialog = false;
          }
          this.loading = false;
          this.$store.dispatch("setSnackbar", {show: true, text: response.data.message, color: color, x: "left", timeout: 3000});
      },
  }
};
</script>

<style scoped>

</style>
